const FileSelectorMixin = {
  totalNumberOfFilesSelected() {
    return this.filesSelected().length;
  },

  filesSelected() {
    const { service } = this.props;
    return (this.files || []).map((f) => {
      f.service = service;
      return f;
    });
  },

  removeFile(file) {
    const index = this.files.indexOf(file);
    if (index === -1) {
      return;
    }

    this.files.splice(index, 1);
    delete file.selected;
  },

  clear() {
    this.files = [];

    if (typeof this._clear === 'function') {
      this._clear();
    }
  },
};

export default FileSelectorMixin;
